import { useTranslation } from 'react-i18next';

const ruleKeys = [
  { icon: 'ri-forbid-2-line', key: 'rule_no_smoking', allowed: false },
  { icon: 'ri-forbid-2-line', key: 'rule_no_parties', allowed: false },
  { icon: 'ri-check-line', key: 'rule_pets_allowed', allowed: true },
  { icon: 'ri-check-line', key: 'rule_private_entrance', allowed: true },
  { icon: 'ri-check-line', key: 'rule_calm', allowed: true },
  { icon: 'ri-check-line', key: 'rule_family', allowed: true },
];

export default function GolfoRules() {
  const { t } = useTranslation();

  return (
    <section id="rules" className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">{t('rules_subtitle')}</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">{t('rules_title')}</h2>
        </div>

        <div className="bg-background-100 rounded-lg p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
            {ruleKeys.map((rule) => (
              <div key={rule.key} className="flex items-center gap-3 p-3 rounded-lg">
                <span className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ${rule.allowed ? 'bg-accent-50 text-accent-600' : 'bg-red-50 text-red-500'}`}>
                  <i className={`${rule.icon} text-sm`}></i>
                </span>
                <span className="text-sm text-foreground-700 font-medium">{t(rule.key)}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-background-200">
            <div className="text-center">
              <p className="text-xs text-foreground-500 uppercase tracking-wider mb-1">{t('license_number')}</p>
              <p className="text-base font-semibold text-foreground-950 font-heading">V-35-3-0000789</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}